import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { KnownBusinessEntitySaleItem } from "@/models/known-business-entity-sale-item.model.ts"
import { usePriceAgreementsConstantTimeLookup } from "@/composables/store/price-agreements-constant-time-lookup"

export const useKnownBusinessEntitiesSaleItemsStore = defineStore(
  "knownBusinessEntitiesSaleItemsStore",
  () => {
    const knownBusinessEntitiesSaleItems: Ref<KnownBusinessEntitySaleItem[]> = ref([])

    const { getPriceAgreement, getUnitPrice } =
      usePriceAgreementsConstantTimeLookup<KnownBusinessEntitySaleItem>(
        knownBusinessEntitiesSaleItems,
        (item) => [item.knownBusinessEntity, item.saleItem],
        (item) => item.unitPrice
      )

    return {
      knownBusinessEntitiesSaleItems,
      getPriceAgreement,
      getUnitPrice
    }
  }
)
